import { render } from "./ReceiveTransfer.vue?vue&type=template&id=05238db4"
import script from "./ReceiveTransfer.vue?vue&type=script&lang=js"
export * from "./ReceiveTransfer.vue?vue&type=script&lang=js"

import "./ReceiveTransfer.vue?vue&type=style&index=0&id=05238db4&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__